package com.appcreator.blueprint.actions

import com.appcreator.blueprint.core.Action
import kotlinx.serialization.Serializable

@Serializable
data object UnsupportedAction: Action